const isRecaptchaEnabled = () => {
	return window.REACT_APP_GOOGLE_RECAPTCHA_ENABLED
}

export default isRecaptchaEnabled
